<template> 
  <modal v-model="show"
         max-width="500"
         :has-padding="false">      
    <button class="btn btn-primary btn-extra-round"
            slot="activator"
            @click="reset()">
      {{dataActivatorText}}
    </button>

    <div :key="data.id">
        <app-tag-form-body ref="body"
                           v-model="data"
                           @input="input"
                           @valid="save"></app-tag-form-body>
        <div class="card-footer">
            <button class="btn btn-primary btn-round" @click="validate()">
                Salvar
            </button>
        </div>
    </div>
  </modal>   
</template>

<script>
    import AppTagFormBody from './components/TagFormBody'
    import EventBus from '@packages/event-bus/index'
    import Modal from "@/components/generic/Modal";

    export default {
        components: {
            AppTagFormBody,
            Modal
        },

        data() {
            return {
                show: false,
                data : {}
            }
        },

        props: {
            dataActivatorText: {
                type: String,
                required: true
            }
        },

        computed: {
        },

        methods: {


            input(value) {
                this.data = value
            },
            reset(){
                this.data = {}
            },
            async edit(tag) {
                this.show = true
                this.data = tag
            },
            validate() {
                this.$refs.body.validate()
            },
            async save() {
                if (this.data.id) {
                    await this.$api.tag.update(this.data)
                } else {
                    await this.$api.tag.create(this.data)
                }

                EventBus.$emit(`LOAD_TAGS`)
                this.show = false
            },

        },
        mounted() {
            EventBus.$on('EDIT_TAG', this.edit)
        },
        beforeDestroy() {
            EventBus.$off('EDIT_TAG', this.edit)
        },
    }
</script>

<style lang="scss" scoped>

    .card-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 15px;

        .btn {
            margin: 15px;
        }
    }

    .modal-round .v-card .card-body {
        min-height: 160px;
    }
</style>
